import { useTranslation } from 'react-i18next';
import { Link } from 'wouter';

// Official browser marks (alrra/browser-logos), served from public/browsers/.
const BROWSERS: { name: string; src: string }[] = [
  { name: 'Chrome', src: '/browsers/chrome.svg' },
  { name: 'Firefox', src: '/browsers/firefox.svg' },
  { name: 'Edge', src: '/browsers/edge.svg' },
  { name: 'Brave', src: '/browsers/brave.svg' },
  { name: 'Vivaldi', src: '/browsers/vivaldi.svg' },
];

export function HomeBrowserStrip() {
  const { t } = useTranslation();

  return (
    <section className="mx-auto max-w-6xl px-4 py-10 sm:px-6 sm:py-14">
      <p className="text-center font-display text-xs font-semibold uppercase tracking-[0.16em] text-zinc-400 dark:text-zinc-500">
        {t('home.browsers.eyebrow')}
      </p>
      <div className="mt-6 flex flex-wrap items-center justify-center gap-3 sm:gap-4">
        {BROWSERS.map((b) => (
          <Link
            key={b.name}
            href="/download"
            aria-label={t('home.browsers.getFor', { browser: b.name })}
            className="flex items-center gap-2.5 rounded-2xl border border-zinc-200 bg-white px-4 py-2.5 shadow-sm outline-none transition-colors hover:border-violet-300 hover:bg-zinc-50 focus-visible:ring-2 focus-visible:ring-violet-500 dark:border-white/10 dark:bg-white/[0.02] dark:hover:border-violet-500/40 dark:hover:bg-white/[0.05]"
          >
            <img src={b.src} alt="" aria-hidden width={24} height={24} loading="lazy" className="h-6 w-6" />
            <span className="font-display text-sm font-semibold text-zinc-700 dark:text-zinc-200">{b.name}</span>
          </Link>
        ))}
      </div>
    </section>
  );
}
